var angular = require('angular');
const { max } = require('underscore');

/* credit: https://css-tricks.com/text-fade-read-more/ */

angular
  .module("app.directives")
  .directive('readMore', function($document) {
    return {
      restrict: 'E',
      require: [ 'readMore' ],
      template: require('./index.pug'),
      transclude: true,
      replace: true,
      scope: {
        includeLess: '@',
        centre: '@'
      },
      controller: function($scope) {
      },
      link: function(scope, element, attrs, requires) {
        var controller = requires[0];
        scope.expanded = false;

        if (attrs.centre === undefined || attrs.centre == true){
          $(element).find('.read-more,.read-less').css({"text-align": 'center'})
        }
        else{
          $(element).find('.read-more,.read-less').css({"text-align": 'left'})
        }

        // auto show/hide button based on content size
        scope.$watch(function() { return $(element).outerHeight(); }, function() {
          if (scope.expanded) return;
          if ($(element).outerHeight() < 150) {
            $(element).children('.read-more').hide();
          } else {
            $(element).children('.read-more').show();
          }
        });

        // add read more button click handler
        var $el, $ps, $up, totalHeight;
        $(element).children('.read-more,.read-less').children('a').click(function() {
          scope.expanded = !scope.expanded;
          $el = $(this);
          $up = $el.closest(".read-more-box");
          $ps = $up.children(":not('.read-more')");

          // Tot up the height of all the content
          totalHeight = 0;
          $ps.each(function() { totalHeight += $(this).outerHeight(); });

          if (scope.expanded) {
            $up.find(".read-more").css({"display": "none" });
            if (attrs.includeLess){
              $up.find(".read-less").css({"display": "initial"});
            }
          }

          // Set height of container, animating
          var totalHeight = scope.expanded ? totalHeight : 150;
          $up.animate({ "max-height": scope.expanded ? 9999 : 150 }, 
                      400,
                      function(){
                        // Hide Read-more line.
                        if (!scope.expanded) {
                          $up.find(".read-more").css({"display": "initial" });
                          $up.find(".read-less").css({"display": "none"});
                        }
                      }
          );

          return false;
        });
      }
    };
  });
